import React from "react";
import { BsCheck2 } from "react-icons/bs";

function IronHead() {
    return (
        <>
            <section id="iron_head" className="iron_head bg_dark page-section Build_your_iron" style={{ background: "#1d2025" }}>
                <div className="container-xl">
                    {/* <div className="d-flex align-items-center justify-content-between sec_tile_bar">
                        <h2 className="sec_title">Iron Head</h2>
                    </div> */}
                    <div className="row justify-content-center">
                        <div className="col-lg-5 col-md-6">
                            <div className="iron_content">
                                <h1 className="">
                                    Build your <br /> iron heads.
                                </h1>
                                <h2 className="">
                                    <span className="hide_mobile">
                                        Go through the selections below to build a <br />
                                        custom set of Foreward iron heads in PW <br />
                                        through 4 iron.
                                    </span>
                                </h2>
                                <h2 className="show_mobile">
                                    <span>
                                        Go through the selections below to build a<br/>
                                        custom set in PW through 4 Iron.
                                    </span>
                                </h2>
                            </div>
                        </div>
                        <div className="col-xl-4 col-lg-5 col-md-6 iron_step_container">
                            <div className="iron_step">
                                <div className="iron_step_item">
                                    <div className="iron_step_icon2">
                                        <BsCheck2 />
                                    </div>
                                    <div className="iron_step_content">
                                        <h3>Choose your bounce</h3>
                                        <p>Get the sole design that suits your swing</p>
                                    </div>
                                </div>
                                <div className="iron_step_item">
                                    <div className="iron_step_icon2">
                                        <BsCheck2 />
                                    </div>
                                    <div className="iron_step_content">
                                        <h3>Choose your finish</h3>
                                        <p>Pick the club head finish you want to play</p>
                                    </div>
                                </div>
                                <div className="iron_step_item">
                                    <div className="iron_step_icon2">
                                        <BsCheck2 />
                                    </div>
                                    <div className="iron_step_content last_iron">
                                        <h3>Choose your ports</h3>
                                        <p className="mb-0">Pick the port finish to accent your heads</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default IronHead;